var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-grow truncate", attrs: { title: _vm.data.name } },
    [
      _c(
        "div",
        {
          staticClass: "flex items-center gap-2 truncate",
          class: {
            "py-4 border-b border-grey-200 pointer-events-none": _vm.readOnly
          },
          attrs: { id: "prompting-item" },
          on: {
            mouseenter: function($event) {
              _vm.isHovered = true
            },
            mouseleave: function($event) {
              _vm.isHovered = false
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-center justify-center flex-shrink-0 w-10 text-sm font-semibold text-center text-teal-700 bg-teal-100 rounded outline-none h-11"
            },
            [
              _c("BlTextBody1", {
                staticClass: "font-semibold text-teal-700",
                attrs: { text: _vm.data.abbreviation }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "flex items-center flex-grow h-10 px-1 rounded outline-none",
              class: { "bg-slate-200": _vm.isHovered && !_vm.data.is_default }
            },
            [
              _c("BlTextBody1", {
                staticClass: "text-slate-1000",
                attrs: { text: _vm.data.name }
              })
            ],
            1
          ),
          _vm._v(" "),
          !_vm.data.is_default
            ? _c("div", { staticClass: "relative self-start ml-auto" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "absolute flex items-center gap-2 transition-opacity duration-300 top-0.5 right-1",
                    class: {
                      "opacity-100": _vm.isHovered,
                      "opacity-0": !_vm.isHovered
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "p-2 bg-white border rounded cursor-pointer border-slate-500 ",
                        on: { click: _vm.onRemove }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "w-4 h-4 ",
                          attrs: {
                            icon: "delete",
                            color: _vm.disabledDelete ? "grey" : "error",
                            tooltip: _vm.tooltipDelete
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "p-2 bg-white border rounded cursor-pointer border-slate-500",
                        on: {
                          click: function($event) {
                            _vm.openEdit = true
                          }
                        }
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "w-4 h-4 ",
                          attrs: { icon: "pencil-outline", color: "grey" }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.openEdit
        ? _c(
            "BlBackdrop",
            {
              attrs: { title: "Edit prompt", label: "Update" },
              on: {
                "backdrop-close": function($event) {
                  _vm.openEdit = false
                },
                "backdrop-action": _vm.onUpdate
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex flex-col gap-5 px-8 overflow-y-auto",
                  style: { width: "40rem", maxHeight: "calc(100vh - 14rem)" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "grid items-center grid-cols-6 gap-4 py-4" },
                    [
                      _c("BlInputText", {
                        staticClass: "col-span-3",
                        attrs: {
                          input: {
                            label: "Score",
                            placeholder: "Type score",
                            model: _vm.data.score,
                            inputType: "number",
                            suffix: "%",
                            min: 0,
                            max: 100
                          }
                        },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlInputText", {
                        staticClass: "col-span-3",
                        attrs: {
                          input: {
                            label: "Code",
                            placeholder: "Type code",
                            model: _vm.data.abbreviation
                          }
                        },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      _c("BlInputText", {
                        staticClass: "col-span-6",
                        attrs: {
                          input: {
                            label: "Prompt name",
                            placeholder: "Type name",
                            model: _vm.data.name
                          }
                        },
                        on: { changed: _vm.inputHandler }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bbb9abd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bbb9abd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/repository/sbt/PromptingClientItem.vue
// module id = null
// module chunks = 